<template>
  <div class="login-layout blur-login">
  <div class="main-container">
    <div class="main-content">
      <div class="row">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="login-container">
            <div class="position-relative">
              <div id="forgot-box" class="forgot-box visible widget-box no-border">
                <template v-if="sucessStatus === true">
                  <div class="widget-body">
                    <div class="widget-main">
                      <h4 class="header red lighter bigger">
                        <i class="ace-icon fa fa-key"></i>
                        パスワードリセット
                      </h4>
                      <div class="space-6"></div>
                      <div class="alert alert-success">
                        {{ message }}
                      </div>
                    </div><!-- /.widget-main -->

                    <div class="toolbar center">
                      <router-link tag="a" :to="{ name: 'login'}" class="back-to-login-link">
                        <i class="ace-icon fa fa-arrow-right"></i>
                        ログインページに戻る
                      </router-link>
                    </div>
                  </div><!-- /.widget-body -->
                </template>
                <template v-else>
                  <div class="widget-body">
                    <div class="widget-main">
                      <h4 class="header red lighter bigger">
                        <i class="ace-icon fa fa-key"></i>
                        パスワードリセット
                      </h4>
                      <div class="space-6"></div>
                      <div class="alert alert-danger" v-if="error === true">
                        {{ message }}
                      </div>
                      <form @submit.prevent="validateBeforeSubmit">
                        <fieldset>
                          <label class="block clearfix">
                            <span v-show="errors.has('ownerId')" class="error">{{ errors.first('ownerId') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('ownerId') }" name="ownerId" type="text" class="form-control" v-validate="'required'" disabled  placeholder="事業者ID" v-model="credentials.ownerId" data-vv-as="名前"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <label class="block clearfix">
                            <span v-show="errors.has('userId')" class="error">{{ errors.first('userId') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('userId') }" disabled v-validate="'required'" name="userId" type="text" class="form-control" placeholder="ユーザーID" v-model="credentials.userId"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <label class="block clearfix">
                            <span v-show="errors.has('resetCode')" class="error">{{ errors.first('resetCode') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('resetCode') }" v-validate="'required|numeric'" name="resetCode" type="text" class="form-control" placeholder="メールにて通知されたリセットコードを入力" v-model="credentials.resetCode"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <span class="warring">
                            パスワードは英大文字、英小文字、数字を組み合わせた8文字以上に設定してください。
                          </span>
                          <label class="block clearfix">
                            <span v-show="errors.has('newPassword')" class="error">{{ errors.first('newPassword') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('newPassword') }" v-validate="'regex:^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])'" name="newPassword" type="password" class="form-control" placeholder="新しいパスワード" v-model="credentials.newPassword"/>
                              <i class="ace-icon fa fa-lock"></i>
                            </span>
                          </label>
                          <label class="block clearfix">
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('newPassword') }" v-validate name="newPassword" data-vv-rules="required|confirmed:newPassword" type="password" class="form-control" placeholder="再記入新しいパスワード"/>
                              <i class="ace-icon fa fa-lock"></i>
                            </span>
                          </label>
                          <div class="clearfix">
                            <router-link tag="button" :to="{ name: 'forgotpassword'}" class="width-40 pull-left btn btn-sm">
                              戻る
                            </router-link>
                            <button type="submit" class="width-40 pull-right btn btn-sm btn-danger">
                              <span class="bigger-110">送信</span>
                            </button>
                          </div>
                        </fieldset>
                      </form>
                    </div><!-- /.widget-main -->
                  </div><!-- /.widget-body -->
                </template>
              </div><!-- /.forgot-box -->
            </div><!-- /.position-relative -->
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.main-container -->
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      credentials: {
        ownerId: '',
        userId: '',
        resetCode: '',
        newPassword: ''
      },
      sucessStatus: false,
      error: '',
      message: ''
    }
  },
  created () {
    this.credentials.ownerId = localStorage.ownerId
    this.credentials.userId = localStorage.userId
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const credentials = {
            ownerId: this.credentials.ownerId,
            userId: this.credentials.userId,
            resetCode: this.credentials.resetCode,
            newPassword: this.credentials.newPassword
          }
          this.$http.post(Config.RESET_PASSWORD_API, JSON.stringify(credentials))
            .then(response => {
              if (response.body.message === 'Success') {
                this.sucessStatus = true
                this.message = Config.RESET_API_SUCCESS_RESET_PASSWORD
              } else {
                this.error = true
                this.message = Config.RESET_API_ERROR_RESET_PASSWORD
              }
            })
            .catch((error) => {
              if (error.body) {
                this.error = true
                switch (error.status) {
                  case 400:
                    this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                    break
                  case 444:
                    this.message = '事業者ID、ユーザーIDもしくはリセットコードが間違っています。'
                    break
                  case 445:
                    this.message = '事業者ID、ユーザーIDもしくはリセットコードが間違っています。'
                    break
                  case 500:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                  case 503:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                  default:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                }
              } else {
                this.error = true
                this.message = Config.SERVER_CONNECT_ERROR
              }
            })
        }
      })
    }
  }
}
</script>

<style>
.warring{
  background-color: #f2dede;
  border-color: #ebccd1;
  color: #a94442;
  padding: 8px 0px;
  display: inline-block;
  font-size: 14px;
  margin-bottom:5px
}
body{
  background: #394557
}
span.error {
  color: red;
}
input {
  border: 1px solid black;
}
input.error {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/views/login/ResetPassword.vue